export default (arr) => {
  return Math.max(...arr)
}